
const Footer = () => {
  return (
    <footer style={footerStyle}>
      <p>&copy; {new Date().getFullYear()} Seek Nostalgia. All Rights Reserved.</p>
      <p>Please note that many of the products recommended here are affiliate links that help support the site. Thanks!</p>
    </footer>
  );
};

const footerStyle = {
  position: "relative",
  bottom: 0,
  width: "98%",
  backgroundColor: "#f5eedc",
  color: "black",
  textAlign: "center",
  padding: "10px",
  left: 0,
  fontSize: "12px",
  marginTop: "200px",
};

export default Footer;
